"use client";

import InvoiceUploadView from "./InvoiceUploadView";

export default function InvoiceUploadPage({ userId }) {
  const handleUploadSuccess = (newBills) => {
    console.log("Bills uploaded successfully:", newBills);
    // Optionally redirect or show a success message
  };

  return (
    <div className=" px-4 py-6 bg-gray-300 mt-2 rounded-lg">
      <div>
        <InvoiceUploadView
          userId={userId}
          onUploadSuccess={handleUploadSuccess}
        />
      </div>
    </div>
  );
}
